import TrailerBlockerOverlayWrapper from '@components/Video/Trailer/TrailerBlockerOverlay/TrailerBlockerOverlayWrapper'

import TrailerBlockerOverlay from './TrailerBlockerOverlay'

const exports = {
  TrailerBlockerOverlay,
  TrailerBlockerOverlayWrapper,
}

export default exports
